export default "__VITE_ASSET__CdxX_F8c__"